import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';
import Value from './common/Value';
import { formatAddress } from '../../utils/utils';
import { getFormattedShipperDetailsData } from './utils';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  shipperValue: {
    fontSize: theme.headerTextFontSize,
    marginBottom: 4
  },
  shipperDetailContainer: {
    margin: '16px 0px'
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: 16,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  detailItem: {
    flex: 1,
    maxWidth: '32%'
  }
});

const ShipperDetails = ({ classes, proData }) => {
  return (
    <div className={classes.container}>
      <Label labelText="Shipper Details" />
      <div className={classes.shipperDetailContainer}>
        <Value value={proData.shipperName} customClasses={classes.shipperValue} />
        <Label
          labelText={formatAddress({
            address: proData.shipperAddress,
            address2: proData.shipperAddress2,
            city: proData.shipperCity,
            state: proData.shipperState,
            zip: proData.shipperZip
          })}
          upperCase={false}
        />
      </div>
      {getFormattedShipperDetailsData(proData).map((detailsGroup, index) => (
        <div key={index} className={classes.detailsContainer}>
          {detailsGroup.map(detail => (
            <Detail
              key={detail.label}
              label={detail.label}
              value={detail.value}
              detailContainerClasses={classes.detailItem}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(ShipperDetails);
